import { render } from "./SurveyQ9.vue?vue&type=template&id=0c30589c&ts=true"
import script from "./SurveyQ9.vue?vue&type=script&lang=ts"
export * from "./SurveyQ9.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__